<template>
    <b-form-select v-bind:id="id" v-bind:name="name" v-model="selectedMonth" :options="options" :state="state"></b-form-select>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            default: null,
        },
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        state: {
            type: String,
            default: null,
        },
    },
    computed: {
        selectedMonth: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    data() {
        return {
            options: [],
        };
    },
    mounted() {
        for (let i = 1; i <= 12; i++) {
            this.options.push({ value: i, text: i + "月" });
        }
    }
}
</script>